




























import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class ClientUnitsExistConfirmDialog extends BaseComponent {
  @Prop()
  items: any;

  formOpen = false;
  options = [];
  selected = null;

  @Watch('items', { immediate: true })
  onItemsChange() {
    this.options = this.items.map((i) => {
      return { id: i.id, nome: 'Utilizar existente: ' + i.nome };
    });
    this.options.push({ id: null, nome: 'Novo Prospect' });
  }

  mounted() {
    this.formOpen = true;
  }

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo']
  };

  public form: any = {
    valid: false
  };

  public headers: any = [
    { text: '', value: '', sortable: false, width: '10' },
    { text: 'Nome', value: 'nome', sortable: false, width: '10000px' }
  ];

  confirm() {
    this.$emit('select', this.selected);
  }
}
